import React from 'react';

import { TableSettingsConfig } from './types';

type Props = Readonly<{
    settings?: TableSettingsConfig;
    children: React.ReactNode;
}>;

export default function TableBody({ settings, children }: Props) {
    function getTableRows() {
        if (!settings) {
            return children;
        }

        return React.Children.map(children, (row) => {
            if (!React.isValidElement(row) || row.type !== 'tr') {
                return row;
            }

            const visibleCells = React.Children.toArray(row.props.children).map((cell, index) => {
                return settings.hiddenColumns.includes(index) ? null : cell;
            });

            return React.cloneElement(row as React.ReactElement, { children: visibleCells });
        });
    }

    return <tbody>{getTableRows()}</tbody>;
}
